import { PublicPage } from '../base.js';

export class Registered extends PublicPage {
  static timl = `
    section.auth-page[aria-labelledby="registered-title"]
      .stacked-form.auth-form.auth-status
        header.auth-header
          h1#registered-title Check your inbox
          p We sent you a confirmation link. Open it to verify your email address and finish creating your account.
        a.auth-primary.auth-primary-link[href="/resend-confirmation"] Resend confirmation email
        .auth-divider[aria-hidden="true"]
          span or
        p.auth-switch
          span Already confirmed?
          a[href="/login"] Log in
  `;
}
